'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var signup = require('./signup.js');
var getAmlStatus = require('./getAmlStatus.js');
require('../../util/interfaces.js');
var user_constants = require('../../util/user.constants.js');
require('../../util/normalize.js');
require('../../util/date.js');
require('../../util/static-content.js');
var transport = require('../../transport/transport.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Users {
  addNote(params) {
    return transport.transport.request("users/addNote", params);
  }
  subscribe(params) {
    return transport.transport.subscribe(params);
  }
  unsubscribe(params) {
    return transport.transport.unsubscribe(params);
  }
  agreedCompliance(params) {
    return transport.transport.request("users/agreedCompliance", params);
  }
  getProfileV2() {
    return transport.transport.request("users/getProfileV2");
  }
  getProfile() {
    return transport.transport.request("users/getProfile");
  }
  updateProfile(params) {
    return transport.transport.request("users/updateProfile", params);
  }
  updateProfileV2(params) {
    return transport.transport.request("users/updateProfileV2", params);
  }
  getBankIdiFrameDetails(params) {
    return transport.transport.request("users/getBankIdiFrameDetails", params).then((payload) => payload.redirectOutput || payload);
  }
  getSportncoLaunchURL(params) {
    return transport.transport.request("users/getSportncoLaunchURL", params);
  }
  getSportncoToken() {
    return transport.transport.request("users/getSportncoToken");
  }
  resendVerificationEmail(params) {
    return transport.transport.request("signup/sendVerifyEmail", params);
  }
  signup(params, lang, quick = false, transparentErrors = false, geoResponse) {
    const _a = params, { userConsents } = _a, authModel = __objRest(_a, ["userConsents"]);
    let endpoint = signup.SignUpEndpoint.SignUpV2;
    if (params.signUpEndpoint) {
      endpoint = params.signUpEndpoint;
    } else if (quick) {
      endpoint = signup.SignUpEndpoint.QuickSignUpV2;
    } else {
      const hasLicenceNo = authModel.driversLicenceNo !== void 0;
      const hasLicenceVer = authModel.driversLicenceVersion !== void 0;
      const hasPassportNo = authModel.passportNo !== void 0;
      const hasPassportExpiry = authModel.passportExpiry !== void 0;
      const hasLotbaFields = this.hasLotbaFields(authModel);
      const hasAGCOFields = this.hasAGCOFields(authModel);
      if (hasAGCOFields) {
        endpoint = signup.SignUpEndpoint.SignUpAGCO;
        this.replaceField(authModel, "firstname", "firstName");
        this.replaceField(authModel, "surname", "lastName");
        this.replaceField(authModel, "verificationTypeID", "verificationType");
        this.replaceField(authModel, "lang", "languageAlpha2Code");
      }
      if (hasLicenceNo && hasLicenceVer || hasPassportNo && hasPassportExpiry) {
        endpoint = signup.SignUpEndpoint.SignUpV2SC;
      }
      if (hasLotbaFields) {
        endpoint = signup.SignUpEndpoint.SignUpLOTBA;
      }
    }
    const data = {
      authModel,
      userConsents,
      lang,
      transparentErrors
    };
    return transport.transport.request(endpoint, geoResponse ? __spreadProps(__spreadValues({}, data), { geoResponse }) : data);
  }
  signupV2(params) {
    const _a = params, { userConsents, signUpEndpoint, lang } = _a, authModel = __objRest(_a, ["userConsents", "signUpEndpoint", "lang"]);
    const endpoint = signUpEndpoint != null ? signUpEndpoint : signup.SignUpEndpoint.SignUpV2;
    const data = {
      authModel,
      userConsents,
      lang,
      transparentErrors: false
    };
    return transport.transport.request(endpoint, data);
  }
  replaceField(authModel, oldField, newField) {
    authModel[newField] = authModel[oldField];
    delete authModel[oldField];
  }
  getCountries() {
    return transport.transport.request("signup/getCountries");
  }
  impersonate(token) {
    return transport.transport.request("users/impersonate", token);
  }
  login(params) {
    return transport.transport.request("users/login", params);
  }
  loginV2(params) {
    return transport.transport.request("users/loginV2", params);
  }
  resumeLogin() {
    return transport.transport.request("users/resumeLogin");
  }
  resumeLoginV2() {
    return transport.transport.request("users/resumeLoginV2");
  }
  isLoggedIn() {
    return transport.transport.request("users/isLoggedIn");
  }
  authenticateWithChallengeToken(params) {
    return transport.transport.request("users/authenticateWithChallengeToken", params);
  }
  completeRegistration(params) {
    return transport.transport.request("users/completeRegistration", params);
  }
  logout() {
    return transport.transport.request("users/logout");
  }
  hasPendingConsents() {
    return transport.transport.request("users/hasPendingConsents");
  }
  userPendingConsents(params) {
    return transport.transport.request("users/userPendingConsents", params);
  }
  resetPasswordRequestV1(params) {
    return transport.transport.request("users/sendResetPwdEmail", params);
  }
  resetPasswordRequest(params) {
    return transport.transport.request("users/sendResetPwdEmailV2", params);
  }
  resetPassword(params) {
    return transport.transport.request("users/resetPassword", params);
  }
  sendResetPwdSMS(params) {
    return transport.transport.request("users/sendResetPwdSMS", params);
  }
  resetPasswordSMS(params) {
    return transport.transport.request("users/resetPasswordSMS", params);
  }
  bonus(params) {
    return transport.transport.request("users/bonus", params);
  }
  verifyEmail(params) {
    return transport.transport.request("users/verifyEmail", params);
  }
  getSOWQ() {
    return transport.transport.request("users/getSOWQ");
  }
  postSOWQ(params) {
    return transport.transport.request("users/postSOWQ", params);
  }
  getIdDocTypes() {
    return transport.transport.request("users/getIdDocTypes");
  }
  getAmlVerificationStatus() {
    return transport.transport.request("users/getAmlVerificationStatus");
  }
  getGracePeriod() {
    return transport.transport.request("users/getGracePeriod");
  }
  sessionTurnover() {
    return transport.transport.request("users/sessionTurnover");
  }
  getPreferences() {
    return transport.transport.request("users/getPreferences");
  }
  getRealityCheckOptions() {
    return transport.transport.request("users/getRealityCheckOptions").then((payload) => __spreadProps(__spreadValues({}, payload), {
      availableValues: payload.availableValues.filter((value) => value !== `${user_constants.REALITY_CHECK_DISABLED_VALUE}`)
    }));
  }
  setPreferences(params) {
    return transport.transport.request("users/setPreferences", {
      preference: params
    });
  }
  setRealityCheck(params) {
    return transport.transport.request("users/setRealityCheck", params);
  }
  getRealityCheck() {
    return transport.transport.request("users/getRealityCheck");
  }
  getLoginHistory(params) {
    return transport.transport.request("users/getLoginHistory", params);
  }
  getConsents(params) {
    return transport.transport.request("users/getConsents", params);
  }
  getUserConsents(params) {
    return transport.transport.request("users/userConsents", params);
  }
  saveUserConsents(params) {
    return transport.transport.request("users/saveUserConsents", params);
  }
  detailsUpdateRequest() {
    return transport.transport.request("users/detailsUpdateRequested");
  }
  setUserOnSiteMarketing(params) {
    return transport.transport.request("users/setUserOnSiteMarketing", params);
  }
  changePassword(params) {
    return transport.transport.request("users/changePassword", params);
  }
  changeEmail(params) {
    return transport.transport.request("users/changeEmail", params);
  }
  closeAccount(params) {
    return transport.transport.request("users/closeAccount", params);
  }
  closeAccountV2(params) {
    return transport.transport.request("users/closeAccountV2", params);
  }
  verifySMS(params) {
    return transport.transport.request("signup/verifySMS", params);
  }
  isEmailAvailable(params) {
    return __async(this, null, function* () {
      const res = yield transport.transport.request("signup/checkEmail", params);
      return res.isAvailable;
    });
  }
  isUsernameAvailable(params) {
    return __async(this, null, function* () {
      const res = yield transport.transport.request("signup/checkUsername", params);
      return res.isAvailable;
    });
  }
  getAmlStatus() {
    return transport.transport.request("users/getAMLStatus");
  }
  getPepDetails() {
    return transport.transport.request("signup/retrievePepAdditionalDetails");
  }
  savePepDetails(params) {
    return transport.transport.request("signup/savePepAdditionalDetails", params);
  }
  uploadKYC(params) {
    return this.uploadKycRequest(params, "uploadKYC");
  }
  requestAndUploadKYC(params) {
    return transport.transport.uploadFiles("requestAndUploadKYC", params.files || params.file, params.onProgressChange, {
      documentType: params.type
    });
  }
  updateLanguage(lang) {
    return transport.transport.request("users/setLanguage", { lang });
  }
  kycDocumentRequest(params) {
    return transport.transport.request("users/kycDocumentRequest", params);
  }
  verifyWithDataZoo(params) {
    return transport.transport.request("users/verifyWithDataZoo", params);
  }
  listSecurityQuestions() {
    return transport.transport.request("users/listSecurityQuestions");
  }
  changeSecurityQuestion(params) {
    return transport.transport.request("users/changeSecurityQuestionV2", params);
  }
  getSecurityQuestions(params) {
    return transport.transport.request("users/getSecurityQuestionV2", params);
  }
  getUserActiveBlocks() {
    return transport.transport.request("users/getUserActiveBlocks");
  }
  getKycVerificationUrl() {
    return transport.transport.request("users/getkycverificationurl");
  }
  notificationMessage(params) {
    return transport.transport.request("users/notificationMessage", params);
  }
  linkSlotboxLandBaseUser() {
    return transport.transport.request("users/linkSlotboxLandBaseUser");
  }
  getOmniUserDetails() {
    return transport.transport.request("users/getOmniUserDetails");
  }
  getAuthenticationMethod() {
    return transport.transport.request("users/getAuthenticationMethod");
  }
  setAuthenticationMethod(params) {
    return transport.transport.request("users/setAuthenticationMethod", params);
  }
  sendSMS() {
    return transport.transport.request("users/sendSMS");
  }
  getGameSessionSummary() {
    return transport.transport.request("users/getGameSessionSummary");
  }
  signUpDGE(authModel, lang, userConsents) {
    const data = {
      authModel,
      userConsents,
      lang
    };
    return transport.transport.request("users/signUpDGE", data);
  }
  signUpONJN(authModel, lang, userConsents) {
    const data = {
      authModel,
      userConsents,
      lang
    };
    return transport.transport.request("users/signUpONJN", data);
  }
  getKBAQuestions() {
    return transport.transport.request("users/getKBAQuestions");
  }
  verifyKBAAnswers(answeredQuestionnaire) {
    return transport.transport.request("users/verifyKBAAnswers", answeredQuestionnaire);
  }
  getScanVerifyUrl() {
    return transport.transport.request("users/getScanVerifyUrl");
  }
  linkLandBased() {
    return transport.transport.request("users/linkLandBased");
  }
  membershipRegistration(params) {
    return transport.transport.request("users/membershipNumberRegistration", params);
  }
  uploadKycRequest(params, endpoint) {
    const additionalParams = {
      type: params.type
    };
    if (params.type === getAmlStatus.DocumentType.PHOTO_ID && params.docType) {
      additionalParams.docType = params.docType;
    }
    if (params.type === getAmlStatus.DocumentType.SOURCE_OF_WEALTH_DOCUMENTS && params.SOWDType) {
      additionalParams.SOWDType = params.SOWDType;
    }
    return transport.transport.uploadFiles(endpoint, params.files || params.file, params.onProgressChange, additionalParams);
  }
  hasLotbaFields(userModel) {
    return !!(userModel.identificationNumber && userModel.nationalityCode);
  }
  hasAGCOFields(userModel) {
    return !!("employerCountryAlpha2Code" in userModel && "employerIsoCodeSubdivision1" in userModel);
  }
}

exports.Users = Users;
